<template>
    <div id="watchlistOverlay" class="watchlist__overlay">
        <div class="watchlist-bar">
            <div class="container">
                <div class="column-wrapper">
                    <div class="column-block">
                        <p class="employers-count">{{ savedEmployers.length }} Arbeitgeber gemerkt</p>

                        <button class="button openWatchlist" @click="closeWatchlist">
                            <span class="button-text">zurück</span>
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <div class="container">
            <div class="column-block">
                <h1 class="headline xl no-padding">Deine gemerkten Arbeitgeber</h1>
            </div>

            <div class="column-block">
                <div v-if="cases && cases.length > 0 && !loading" class="column-wrapper employers-wrapper">
                    <employer-container v-for="employer in cases" :key="employer.id" :employer="employer" />
                </div>
                <global-loading v-else />
            </div>
        </div>
    </div>
</template>

<script>
import { ref, onMounted, onUnmounted } from 'vue/dist/vue.esm-bundler';
import { useStore } from 'vuex';
import EmployerContainer from './components/employerContainer.vue';
import GlobalLoading from './globalLoading.vue';

export default {
    name: 'WatchlistOverlay',
    components: { GlobalLoading, EmployerContainer },
    setup() {
        const store = useStore();
        const loading = ref(true);
        const savedEmployers = ref(localStorage.getItem('savedEmployers') ? JSON.parse(localStorage.getItem('savedEmployers')) : []);
        const cases = ref([]);
        let lastSavedEmployers = null;

        onMounted(() => {
            setInterval(() => {  // unter Protest von Arne fusch Lösung integriert
                savedEmployers.value = localStorage.getItem('savedEmployers') ? JSON.parse(localStorage.getItem('savedEmployers')) : [];
                if (lastSavedEmployers === null || lastSavedEmployers?.length !== savedEmployers.value.length) {
                    lastSavedEmployers = savedEmployers.value;
                    window.dispatchEvent(new Event('watchlist'));
                }
            }, 3000);

            window.addEventListener('watchlist', () => {
                savedEmployers.value = localStorage.getItem('savedEmployers') ? JSON.parse(localStorage.getItem('savedEmployers')) : [];
                fetchEmployers();
            });
        });

        const fetchEmployers = () => {
            if (savedEmployers.value) {
                if (savedEmployers.value.length === 0) {
                    closeWatchlist();
                } else {
                    loading.value = true;

                    store.state.api.get('/wp/v2/employers?orderby=include&per_page=99&_fields=id,partnercaseregions,benefits,partnercasetopics,acf,_links,_embedded,title,introblock,link&_embed', {
                        params: { include: savedEmployers.value.join(',') }
                    }).then((response) => {
                        cases.value = response.data.filter((c) => savedEmployers.value.includes(c.id));
                        loading.value = false;
                    }).catch(() => {
                        loading.value = false;
                    });
                }
            }
        };

        const shortenText = (text) => {
            const maxLength = 200; // maximum number of characters to extract
            //trim the string to the maximum length
            const trimmedString = text.substr(0, maxLength);
            //re-trim if we are in the middle of a word
            return `${trimmedString.substr(0, Math.min(trimmedString.length, trimmedString.lastIndexOf(' ')))} ...`;
        };

        const toggleFavorite = (employerId) => {
            if (savedEmployers.value.includes(employerId)) {
                savedEmployers.value = savedEmployers.value.filter((item) => item !== employerId);
                localStorage.setItem('savedEmployers', JSON.stringify(savedEmployers.value));
            } else {
                savedEmployers.value = [...savedEmployers.value, employerId];
                localStorage.setItem('savedEmployers', JSON.stringify(savedEmployers.value));
            }

            window.dispatchEvent(new Event('watchlist'));
        };

        const closeWatchlist = () => {
            const overlay = document.getElementById('watchlistOverlay');

            overlay.classList.remove('open');
        };

        return {
            loading,
            cases,
            savedEmployers,
            toggleFavorite,
            shortenText,
            closeWatchlist
        };
    }
};
</script>

<style lang="scss" scoped>
    .watchlist__overlay {
        position: fixed;
        z-index: 5000;
        top: 80px;
        bottom: 0;
        left: 0;
        transform:translateY(-100%);
        width: 100%;
        background: #fff;
        overflow: auto;
        transition: all .35s ease;

        @media screen and (min-width: 769px) {
            top: 100px;
        }

        @media screen and (min-width: 992px) {
            top: 150px;
        }

        &.open {
            transform:translateY(0);
        }

        .watchlist-bar {
            position: sticky;
            z-index: 20;
            top: 0;
            background-color: #001f47;

            .column-block {
                flex-direction: row;
                align-items: center;
                justify-content: flex-end;
                padding-top: 8px;
                padding-bottom: 8px;
                color: #fff;
            }
        }

        .employers-count {
            font-size: 16px;
            opacity: .6;
        }

        .openWatchlist {
            margin: 0;
            padding: 8px 12px;
            border-color: rgba(255, 255, 255, 0.3);
        }

        .container {
            height: auto;

            .headline {
                padding-bottom: 50px;
            }

            .employers-wrapper {
                display: grid;
                grid-template-columns: 1fr;
                gap: 20px;

                @media screen and (min-width: 720px) {
                    grid-template-columns: repeat(2, 1fr);
                }

                @media screen and (min-width: 1024px) {
                    grid-template-columns: repeat(3, 1fr);
                    gap: 40px;
                }

                @media screen and (min-width: 1440px) {
                    grid-template-columns: repeat(3, 1fr);
                    gap: 60px;
                }
            }
        }
    }
</style>
